import React from 'react';
import styled from 'styled-components';
import { PropTypes } from 'prop-types';
import UserAccount from '../../services/UserAccount';
import WindowSize from '../../services/WindowSize';
import Constants from '../../submodules/logictry_config/constants';
import LogictryComponent from '../../submodules/logictry_config/LogictryComponent';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  flex: 1;
  min-height: 100%;
`;

export default class VerticalCenterContent extends LogictryComponent {
  static propTypes = {
    children: PropTypes.any,
    alignTop: PropTypes.bool,
    backgroundColor: PropTypes.string,
    fullscreen: PropTypes.bool,
  }
  componentDidMount() {
    UserAccount.onStateUpdate(this);
    WindowSize.onStateUpdate(this);
  }
  componentWillUnmount() {
    UserAccount.offStateUpdate(this);
    WindowSize.offStateUpdate(this);
  }
  render() {
    const { children, backgroundColor, alignTop, fullscreen } = this.props;
    const { isIphone } = Constants;
    const { mobile } = WindowSize;
    const style = {
      justifyContent: alignTop ? 'unset' : 'center',
      backgroundColor,
    }
    if (alignTop) style.padding = Constants.NormalSectionPadding;
    else if (fullscreen) style.paddingBottom = '3.5rem';
    if (fullscreen && mobile && !isIphone) style.height = 'calc(100vh - 3.5rem)';
    return (
      <Wrapper style={style}>
        {children}
      </Wrapper>
    );
  }
}
